import BadgeEdit from "./Edit";
import {BadgeList} from "./List";
import  {BadgeView}  from "./View";
import BadgeCreate from "./Create";

export {BadgeList,BadgeEdit,BadgeView, BadgeCreate}